module.exports = __webpack_public_path__ + "img/diferencial3.ae194254.png";